import { graphql } from "@opensea/graphql"

export const CollectionShareModalFragment = graphql(`
  fragment CollectionShareModal on Collection {
    slug
    name
    imageUrl
  }
`)
